import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const cornerOffset = '-5px';
const cornerSize = '8px';
const ResizeableThumbnailDragHandleCorner = styled.div.withConfig({
  displayName: "ResizeableThumbnailDragHandleCorners__ResizeableThumbnailDragHandleCorner"
})(["background-color:", ";height:", ";width:", ";opacity:", ";position:absolute;border:1px solid white;cursor:", ";top:", ";bottom:", ";left:", ";right:", ";"], ({
  theme
}) => theme.color['fill-accent-blue-hover'], cornerSize, cornerSize, props => props.selected ? 1 : 0, props => props.cursor ? props.cursor : 'nwse-resize', props => props.top ? props.top : null, props => props.bottom ? props.bottom : null, props => props.left ? props.left : null, props => props.right ? props.right : null);
const ResizeableThumbnailDragHandleCorners = props => {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(ResizeableThumbnailDragHandleCorner
    // @ts-ignore ts-migrate(2769) FIXME: No overload matches this call.
    , {
      left: cornerOffset,
      top: cornerOffset,
      cursor: 'nwse-resize',
      onMouseDown: e => props.handleMouseDown(e, true, true),
      selected: props.selected
    }), /*#__PURE__*/_jsx(ResizeableThumbnailDragHandleCorner
    // @ts-ignore ts-migrate(2769) FIXME: No overload matches this call.
    , {
      left: cornerOffset,
      bottom: cornerOffset,
      cursor: 'nesw-resize',
      onMouseDown: e => props.handleMouseDown(e, true, false),
      selected: props.selected
    }), /*#__PURE__*/_jsx(ResizeableThumbnailDragHandleCorner
    // @ts-ignore ts-migrate(2769) FIXME: No overload matches this call.
    , {
      right: cornerOffset,
      top: cornerOffset,
      cursor: 'nesw-resize',
      onMouseDown: e => props.handleMouseDown(e, false, true),
      selected: props.selected
    }), /*#__PURE__*/_jsx(ResizeableThumbnailDragHandleCorner
    // @ts-ignore ts-migrate(2769) FIXME: No overload matches this call.
    , {
      right: cornerOffset,
      bottom: cornerOffset,
      cursor: 'nwse-resize',
      onMouseDown: e => props.handleMouseDown(e, false, false),
      selected: props.selected
    })]
  });
};
export default ResizeableThumbnailDragHandleCorners;